import { Image, ImageProps } from '@chakra-ui/react';
import React from 'react';

export const CratIcon = React.memo((props: ImageProps) => {
  return <Image src={'/assets/CratLogo.png'} alt="CRAT" {...props} />;
});
